import { useState, useEffect } from "react";
import validator from "validator";
import { format } from "date-fns";
import { useNavigate } from 'react-router-dom';
import { getGeneralTypes, postData, postDataResponse } from "./Services";
import { StyledSelect, InputContainer, InputWrapper, HeaderContainer, HeaderText, NoteField, GreyButton, RedButton, RightJustifyDiv, SubmitSpan, divOverflowHidden, divFloatLeft, divFloatRight, StyledSelectLeft, StyledSelectRight } from "./Style";
import { useMsal } from "@azure/msal-react";
//import { Grid, TextField, Button, Card, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';
import { Grid, TextField, Backdrop, Button, Card, CircularProgress, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ConfirmDialog from "./ConfirmDialog";



const RequestForApprovalForm = ({ onSave, Case = {} }) => {
  const [MatterID, setMatterID] = useState([]);
  const [RequestType, setRequestType] = useState([]);
  const [errorRequest, setErrorRequest] = useState(false);
  //const { register, handleSubmit, watch, control } = useForm();
  const [selectedValueMatterID, setSelectedValueMatterID] = useState("");
  const [selectedRequestType, setSelectedRequestType] = useState("");

  const [RequestDateVal, SetRequestDateVal] = useState(new Date());

  //let watchID = watch("id");
  //const { field } = useController({ name: "MatterIDSelect", control });

  const [userEmail, setUserEmail] = useState('');

  const [requestReasonVal, setRequestReason] = useState('');

  const [isSubmitted, setIsSubmitted] = useState(false);

  const [isValid, setIsValid] = useState(false);

  const { instance } = useMsal();
  const [openDialog, setOpenDialog] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [dialogMessage, SetDialogMessage] = useState("");
  const [isUploading, setUploading] = useState(false);
  const [dialogDestUrl, setDialogDestUrl] = useState("");


  useEffect(() => {
    async function fetchInitialData(_email) {
      //Matter ID dropdown
      const currentAccount = instance.getActiveAccount();
      var body = {};
      if (currentAccount) {
        setUserEmail(currentAccount.username);
        body.email = currentAccount.username;
      }
      const tokenRequest = {
        account: currentAccount, // This is an example - Select account based on your app's requirements
        scopes: ["User.Read"]
      }

      const matterIDResponse = await postDataResponse('/User/MatterList', body);  //await getMatterID(body.email);
      matterIDResponse.errors ? setErrorRequest(true) : setMatterID(matterIDResponse.data);

      //Case Type dropdown
      const RequestTypeResponse = await getGeneralTypes('/Settings/RequestTypes');
      const filteredData = RequestTypeResponse.filter((data) => data.Value.HasPersonnel === false);

      RequestTypeResponse.errors ? setErrorRequest(true) : setRequestType(filteredData);
    }

    fetchInitialData();
  }, [instance, userEmail]);

  const handleSelectChangeMatterID = (event) => {
    setSelectedValueMatterID(event.target.value);



  };

  const handleSelectRequestType = (event) => {
    setSelectedRequestType(event.target.value);

  };

  async function handleSubmit(e) {
    /*
    const errors = validateData();
    if(Object.keys(errors).length)
    {
        setErrors(errors);
        return;
    }

    setErrors({});
    */

    e.preventDefault();
    setUploading(true);
    // Read the form data
    const form = e.target;
    const formData = new FormData(form);

    const formJson = Object.fromEntries(formData.entries());

    let _ctype = formJson.RequestTypeSelect;
    let _mID = formJson.MatterIDSelect;
    let _notes = formJson.txtRequestReason;

    let postObject = {
      EMail: userEmail,
      MatterID: _mID,
      RequestType: _ctype,
      DateOfRequest: format(RequestDateVal.$d, "MM/dd/yyyy"),
      ReasonForRequest: _notes,
      Personnel: null
    };
    /*
        let postResponse = await postDataResponse('/Matter/RequestForApproval', postObject);
    
        if (postResponse.status === 200 || postResponse.status === 201) {
          setIsSubmitted(true);
          navigate('/Success?message=Request for approval Successfully sent to ProLaw');
        }*/

    postDataResponse('/Matter/RequestForApproval', postObject).then((response) => {
      setUploading(false);
      if (response.status === 200 || response.status === 201) {
        setIsSuccess(true);
        //navigate('/Success?message=Request for approval Successfully sent to ProLaw');
        SetDialogMessage("Request for approval Successfully Submitted");
      }
      else {
        setIsSuccess(false);
        SetDialogMessage(response.data);
      }
      setOpenDialog(true);
    });
  };

  const handleCloseDialog = () => { setOpenDialog(false); };

  return (
    <form method="post" onSubmit={handleSubmit}>
      <div>
        <Card className="form-card">
          <CardHeader title="Request For Approval" style={{ backgroundColor: "#8B0E04", color: "#fff" }} />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="MatterIDSelectLbl">Matter ID</InputLabel>
                  <Select
                    labelId="MatterIDSelectLbl"
                    id="MatterIDSelect"
                    name="MatterIDSelect"
                    value={selectedValueMatterID}
                    label="Matter ID"
                    onChange={handleSelectChangeMatterID}
                  >
                    <MenuItem value="">Choose a Matter</MenuItem >
                    {MatterID !== null ? MatterID.map((value) => (
                      <MenuItem key={value.id} value={value.id}>
                        {"\"" + value.id + "\" - " + value.description + " - " + value.clientSort}
                      </MenuItem >
                    )) : <MenuItem ></MenuItem >}
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={12} sm={4} item>
                <FormControl fullWidth margin="normal">


                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker label="Date of Request" name="RequestDate" id="RequestDate" onChange={(newValue) => { SetRequestDateVal(newValue); setIsValid(true); }} value={dayjs('RequestDateVal')} defaultValue={new Date()} />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={8}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="TypeLbl">Type</InputLabel>
                  <Select
                    name="RequestTypeSelect"
                    labelId="TypeLbl"
                    id="RequestTypeSelect"
                    value={selectedRequestType}
                    onChange={handleSelectRequestType}>

                    <MenuItem value="">Choose a Request Type</MenuItem>
                    {RequestType.map((value) => (
                      <MenuItem key={value.Key} value={value.Key}>
                        {value.Value.Description}
                      </MenuItem>
                    ))}

                  </Select>


                </FormControl>
              </Grid>
              <Grid xs={12} item>
                <TextField
                  name="txtRequestReason"
                  label="Reason for Request" variant="outlined" margin="normal"
                  multiline
                  rows={5}
                  maxRows={15}
                  value={requestReasonVal} requestReasonVal
                  onChange={e => setRequestReason(e.target.value)}
                  required
                  fullWidth
                  placeholder="Reason for Request"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button type="submit" variant="contained" style={{ backgroundColor: "rgb(207, 66, 64)" }} fullWidth>Submit</Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button type="reset" variant="contained" style={{ backgroundColor: "rgb(51, 51, 51)" }} value="Reset" fullWidth>Clear</Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={isUploading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      <ConfirmDialog 
          isOpen={openDialog}
          onClose={handleCloseDialog}
          isSuccess={isSuccess}
          message = {dialogMessage}
          destination={dialogDestUrl}
        />
    </form>
  );
};
export default RequestForApprovalForm;
